import { initializeApp, getApps } from 'firebase/app';
import {
  connectAuthEmulator,
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  onIdTokenChanged,
  RecaptchaVerifier,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  signInWithPopup,
  signOut,
  updateProfile,
  type ApplicationVerifier,
  type ConfirmationResult,
} from 'firebase/auth';
import {
  connectFirestoreEmulator,
  getFirestore,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'demo-ftedn-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'demo-ftedn.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'demo-ftedn',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:892558765278:web:ftedn',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'demo-ftedn.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '892558765278',
};

const appName = 'ftedn-creator-client';
export const firebaseApp = getApps().find((existingApp) => existingApp.name === appName)
  ?? initializeApp(firebaseConfig, appName);

export const auth = getAuth(firebaseApp);
export const firestoreDb = getFirestore(firebaseApp);

let emulatorConnected = false;
let firestoreEmulatorConnected = false;

function shouldUseEmulators() {
  return import.meta.env.VITE_USE_FIREBASE_EMULATORS === 'true';
}

if (shouldUseEmulators() && !emulatorConnected) {
  auth.settings.appVerificationDisabledForTesting = true;
  connectAuthEmulator(
    auth,
    import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL || 'http://127.0.0.1:9099',
    { disableWarnings: true },
  );
  emulatorConnected = true;
}

export function connectFirestoreEmulatorIfNeeded() {
  if (!shouldUseEmulators() || firestoreEmulatorConnected) return;

  connectFirestoreEmulator(firestoreDb, '127.0.0.1', 8084);
  firestoreEmulatorConnected = true;
}

export function isUsingFirebaseEmulators() {
  return shouldUseEmulators();
}

export const googleProvider = new GoogleAuthProvider();

export {
  ApplicationVerifier,
  ConfirmationResult,
  GoogleAuthProvider,
  RecaptchaVerifier,
  createUserWithEmailAndPassword,
  onIdTokenChanged,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  signInWithPopup,
  signOut,
  updateProfile,
};
